/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agents_SubInputs */

const en_mk_agents_sub = /** @type {(inputs: Mk_Agents_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect agents through CLI or MCP. Team execution with a subscription login currently supports Claude Code and Codex on your computer.`)
};

const id_mk_agents_sub = /** @type {(inputs: Mk_Agents_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungkan agent melalui CLI atau MCP. Eksekusi tim dengan login langganan saat ini mendukung Claude Code dan Codex di komputer sendiri.`)
};

/**
* | output |
* | --- |
* | "Connect agents through CLI or MCP. Team execution with a subscription login currently supports Claude Code and Codex on your computer." |
*
* @param {Mk_Agents_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agents_sub = /** @type {((inputs?: Mk_Agents_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agents_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agents_sub(inputs)
	return en_mk_agents_sub(inputs)
});